import { DEV } from 'cc/env';
import { Director, director, view, ResolutionPolicy, warn } from 'cc';
import Game from '../../common/scripts/Game';
import I18n from '../../common/scripts/I18n/I18n';
import SceneManager from '../../common/scripts/SceneManager';
import SettingModel, { GameSettingName } from '../../tableEngine/Script/Game/Data/Model/SettingModel';
import DebugModel from '../../tableEngine/Script/Game/Data/Model/DebugModel';
import SupportLanguage from '../../common/scripts/I18n/SupportLanguage';
import AssetLoadingConfigType from '../../common/scripts/Config/AssetLoadingConfigType';
import Delay from '../../common/scripts/Toolkit/Utils/Delay';
import I18nAssetProvider from '../../common/scripts/I18n/I18nAssetProvider';
import { customGameSettingConfig, customGameSettingRegistry } from '../Game/Data/Config/GameSettingConfig';
import { Music } from '../Game/Data/Config/AudioConfig';
import { BGMOption } from '../Game/UI/Popup/BGMDropdown';
import TableGame from '../../tableEngine/Script/System/TableGame';
import { ModelName } from '../../tableEngine/Script/Game/Data/Config/ModelConfig';
import supportPlayType from '../../tableEngine/Script/Game/Data/Config/SupportPlayType';
import environmentConfig, { LobbyEnvironmentConfigType } from '../Game/Data/Config/EnvironmentConfig';
import gameNameConfig from '../Game/Data/Config/GameNameConfig';
import errorEntity from '../Game/Data/Config/errorEntity.json';
import ErrorConfigType from '../../common/scripts/Config/ErrorConfigType';
import i18nAssetPathConfig from '../Game/Data/Config/I18nAssetPathConfig';
import Client from '../Game/Data/Service/LobbyClient';
import { ConfigParamsMap, defaultConfigParamsMap } from '../../common/scripts/Config/EnvironmentConfigType';
import Parameter from '../../common/scripts/Toolkit/Utils/Parameter';
import NodeName, { SceneName } from '../Game/Data/Config/SceneNodeName';
import { PathName } from '../../tableEngine/Script/Game/Data/Config/PathConfig';
import AudioManager from '../../common/scripts/AudioManager';
import audioAssetPathConfig from '../../common/scripts/Config/AudioAssetPathConfig';
import OrientationManager, { Orientation } from '../../common/scripts/OrientationManager';
import LobbyHistoryModel from '../Game/Data/Model/LobbyHistoryModel';
import NotificationPopup from '../../tableEngine/Script/Game/UI/Popup/NotificationPopup';
import FullscreenGestureController from '../../tableEngine/Script/Controller/FullscreenGestureController';
import LobbyHallModel from '../Game/Data/Model/LobbyHallModel';
import LobbyTableModel from '../Game/Data/Model/LobbyTableModel';
import Connection from '../../common/scripts/Connection/Connection';
import NetworkWebSocket from '../../common/scripts/Connection/Network/NetworkWebSocket';
import Cryptor from '../../common/scripts/Toolkit/Helper/Cryptor';
import LobbyUserModel from '../Game/Data/Model/LobbyUserModel';
import CustomLobbyJackpotModel from '../Game/Data/Model/CustomLobbyJackpotModel';
import LobbyGameDefine, { lobbyGameDefine } from '../Game/Data/Config/LobbyGameDefine';
import LobbyCommunicator from '../../lobbyCommunicator/LobbyCommunicator';
import WindowMessageSource from '../../lobbyCommunicator/MessageSource/WindowMessageSource';
import { LobbyMessagePathName, PageName, PageOpenData } from '../../lobbyCommunicator/Data/Lobby.dto';
import SharedAsset from '../Game/Data/GameEntity/SharedAsset';
import Page from '../../common/scripts/Toolkit/Components/Page/Page';

export default class Lobby extends TableGame {
    protected static instance: Lobby = null;

    protected declare _config: LobbyEnvironmentConfigType;
    protected gameDefine: LobbyGameDefine = lobbyGameDefine;
    protected _i18nAssetProvider: I18nAssetProvider;
    protected _notification: NotificationPopup;
    protected _gestureController: FullscreenGestureController;
    private _communicator: LobbyCommunicator = null;
    private _sharedAsset: SharedAsset = null;
    private _pages: { [key in PageName]?: Page } = {};

    public static get Instance() {
        if (!this.instance) {
            const gameInstance = new Lobby();
            TableGame.instance = gameInstance;
            Game.instance = gameInstance;
            this.instance = gameInstance;
        }
        return this.instance;
    }

    public static get connection() {
        return this.Instance._connection;
    }

    public static get define(): LobbyGameDefine {
        return this.Instance.gameDefine;
    }

    public static get communicator() {
        return this.Instance._communicator;
    }

    public static get notification() {
        if (!this.Instance._notification) {
            this.Instance._notification = this.Instance.scene.getNode(NodeName.NotificationPopup).getComponent(NotificationPopup);
        }
        return this.Instance._notification;
    }

    public static get gestureController() {
        if (!this.Instance._gestureController) {
            this.Instance._gestureController = this.Instance.scene.getNode(NodeName.FullscreenGestureController).getComponent(FullscreenGestureController);
        }
        return this.Instance._gestureController;
    }

    public static get sharedAsset() {
        return this.Instance._sharedAsset;
    }
    public static set sharedAsset(value: SharedAsset) {
        if (this.Instance._sharedAsset) {
            warn('shared asset has been set');
        }
        this.Instance._sharedAsset = value;
    }

    public static get currentTable() {
        return super.currentTable as LobbyTableModel;
    }

    public static get user() {
        return super.user as LobbyUserModel;
    }

    public static get history() {
        return super.history as LobbyHistoryModel;
    }

    public static get hall() {
        return super.hall as LobbyHallModel;
    }

    public static get jackpot() {
        return super.jackpot as CustomLobbyJackpotModel;
    }

    public static get config(): Readonly<LobbyEnvironmentConfigType> {
        return this.Instance?._config;
    }

    public get config(): LobbyEnvironmentConfigType {
        return this._config;
    }

    public quickLaunch() {
        this.launch({
            environmentConfig: { ...environmentConfig },
            gameNameConfig,
            errorConfig: errorEntity as ErrorConfigType,
            assetLoadingConfig: { i18n: i18nAssetPathConfig },
        });
    }

    public async relogin() {
        // try {
        //     const request = await fetch(`${this.config.gameDomain}/user/update`, {
        //         headers: {
        //             'cache-control': 'no-cache',
        //             'content-type': 'application/json',
        //             pragma: 'no-cache',
        //             authorization: `Bearer ${this.config.token}`,
        //         },
        //         method: 'POST',
        //         referrerPolicy: 'strict-origin-when-cross-origin',
        //         mode: 'cors',
        //         credentials: 'omit',
        //     });
        //     if (!request.ok) {
        //         return;
        //     }
        //     await request.json().then((response) => {
        //         if (response.Err) {
        //             Lobby.error.handle(response.Err);
        //             return null;
        //         }
        //         return response;
        //     });
        // } catch (e) {
        //     error(e);
        // }
    }

    public initCommunicator() {
        const element: HTMLIFrameElement = document.getElementById('webview') as HTMLIFrameElement;
        this._communicator.attachMessageSource(new WindowMessageSource(window, element.contentWindow));
    }

    public initCommunicatorEvents() {
        this._communicator.initEvent();
        this._communicator.on(LobbyMessagePathName.Close, async () => {
            this._sharedAsset.webViewManager.closeGame();
        });
        this._communicator.on(LobbyMessagePathName.PageOpen, (data: PageOpenData) => {
            const { page: pageName } = data;
            if (pageName === PageName.Jackpot) {
                this._openPage(NodeName.JackpotPage);
            }
        });
        this._communicator.on(LobbyMessagePathName.Language, (data) => {
            this.i18n.changeLanguage(data.language as SupportLanguage);
        });
        this._communicator.on(LobbyMessagePathName.Sound, (data) => {
            Lobby.audio.effectVolume = data.effectVolume;
            Lobby.audio.musicVolume = data.musicVolume;
            Lobby.audio.effectMute = data.effectMute;
            Lobby.audio.musicMute = data.musicMute;
        });
        this._communicator.on(LobbyMessagePathName.ErrorReport, (errorMessage) => {
            this.message.showError(errorMessage);
            this._sharedAsset.webViewManager.loadGameFinish();
            this._sharedAsset.webViewManager.closeGame();
        });
    }

    protected async initConfig(envConfig: LobbyEnvironmentConfigType, configParamsMap: ConfigParamsMap = defaultConfigParamsMap) {
        super.initConfig(envConfig, configParamsMap);
        // use browser language if language is not set
        // if (!Parameter.get(configParamsMap.language) || Parameter.get(configParamsMap.language) === 'device') {
        //     const iso639LanguageUsedByBrowser = Object.values(StandardLanguageCode).find((language) =>
        //         navigator.language.match(language as StandardLanguageCode),
        //     ) as StandardLanguageCode;
        //     this.config.language = StandardLanguageCode.to(iso639LanguageUsedByBrowser);
        // }
    }

    protected initModels() {
        this._communicator = new LobbyCommunicator();
        const client = new Client();
        this.modelMap = {
            [ModelName.User]: new LobbyUserModel(),
            [ModelName.Hall]: new LobbyHallModel(supportPlayType, client),
            [ModelName.History]: new LobbyHistoryModel(client),
            [ModelName.Setting]: new SettingModel(customGameSettingRegistry, customGameSettingConfig),
            [ModelName.Jackpot]: new CustomLobbyJackpotModel(),
            [ModelName.Debug]: this.config.debug ? new DebugModel() : null,
        };
        Object.values(this.modelMap).forEach((model) => model?.init());
    }

    protected initI18n(config: AssetLoadingConfigType): void {
        this._i18nAssetProvider = new I18nAssetProvider(config);
        this._i18n = new I18n(
            {
                initLanguage: this.config.language,
                supportedLanguages: [SupportLanguage.ENG, SupportLanguage.TCH, SupportLanguage.SCH],
            },
            this._i18nAssetProvider,
        );
    }

    protected initAudioManager(): void {
        this._audioManager = new AudioManager([audioAssetPathConfig]);
    }

    protected initOrientationManager(supportRotation: boolean, defaultOrientation?: Orientation) {
        this._orientationManager = new OrientationManager(supportRotation, defaultOrientation, (width, height, orientation) => {
            if (orientation === Orientation.Landscape) {
                throw new Error('landscape orientation is not supported');
            }
            // 直式
            view.setDesignResolutionSize(720, 1280, ResolutionPolicy.SHOW_ALL);
        });
    }

    protected initGlobalExports() {}

    protected initConnection() {
        const { gameDomain, token, connectionTimeoutDuration } = this.config;
        const serverAddress = `${gameDomain}`;
        const cryptor = new Cryptor(token, token.length);
        const network = new NetworkWebSocket(serverAddress, cryptor);
        this._connection = new Connection(network, connectionTimeoutDuration);
        const originSend = this._connection.send;
        let isFirstSend = true;
        const getToken = () => this.config.token;
        this._connection.send = function send(...args: any) {
            const result = originSend.call(this, ...args);
            if (isFirstSend) {
                isFirstSend = false;
                cryptor.key = getToken();
            }
            return result;
        };
        this._connection.on(Connection.EVENT_TYPE.START_RECONNECT, () => {
            isFirstSend = true;
            cryptor.key = getToken();
        });
    }

    protected afterGameLaunched(): void {
        super.afterGameLaunched();
        this.applyLocalConfig();
        this.enableHeartbeatPacket(PathName.Login, PathName.Ack);
        this._handleBGMChange();
        this._handleLanguageChange();
    }

    protected async retrieveToken(config: LobbyEnvironmentConfigType, configParamsMap: ConfigParamsMap = defaultConfigParamsMap) {
        if (DEV) {
            if (!Parameter.get(configParamsMap.token)) {
                const url = await fetch(
                    `https://entry.dev.s7slot.online/api/relay/DummyTransfer/login?AgentName=test_usd&Username=TAKO2&LoginHall=true&HallName=s7_hall`,
                    {
                        // headers: {
                        //     accept: '*/*',
                        //     'accept-language': 'zh-TW,zh;q=0.9,en-US;q=0.8,en;q=0.7',
                        //     'cache-control': 'no-cache',
                        //     'content-type': 'application/json',
                        // },
                        // referrer: 'https://entry.dev.s7slot.online/test',
                        // referrerPolicy: 'strict-origin-when-cross-origin',
                        method: 'GET',
                        mode: 'cors',
                    },
                )
                    .then((res) => res.json())
                    .then((res) => res.URL);
                const urlObject = new URL(url);
                this.config.platformID = +urlObject.searchParams.get(configParamsMap.platformID);
                this.config.walletType = +urlObject.searchParams.get(configParamsMap.walletType);
                this.config.token = urlObject.searchParams.get(configParamsMap.token);
                this.config.isFakeToken = false;
            }
        }
    }

    protected applyLocalConfig() {
        Lobby.setting.loadLocalConfig();
        this._audioManager.musicVolume = Lobby.setting.MusicVolume;
        this._audioManager.effectVolume = Lobby.setting.EffectVolume;
        this._audioManager.musicMute = Lobby.setting.MusicMute;
        this._audioManager.effectMute = Lobby.setting.EffectMute;
    }

    private _handleBGMChange() {
        const allMusics = [Music.BGM_01, Music.BGM_02];
        let isPlayingMusic = false;
        function playMusic(this: Lobby) {
            if (!(this.scene.currentSceneName === SceneName.OuterLobby || this.scene.currentSceneName === SceneName.Lobby)) {
                return;
            }
            const music: Music = allMusics[Lobby.setting.BGM === BGMOption.Random ? Math.floor(Math.random() * allMusics.length) : Lobby.setting.BGM - 1];
            this.audio.playMusic(music);
            isPlayingMusic = true;
        }
        Delay.event(Director.EVENT_AFTER_SCENE_LAUNCH, director, () => !!this.scene).then(() => {
            // register event listener to change music when BGM option changed or scene changed
            Lobby.setting.on(GameSettingName.BGM, playMusic, this);
            this.scene.on(SceneManager.EVENT_TYPE.AFTER_SCENE_CHANGED, () => {
                // only play music in lobby scene and outer lobby scene
                if (this.scene.currentSceneName === SceneName.OuterLobby || this.scene.currentSceneName === SceneName.Lobby) {
                    if (!isPlayingMusic) {
                        playMusic.call(this);
                    }
                } else {
                    this.audio.stopMusic();
                    isPlayingMusic = false;
                }
            });
            playMusic.call(this);
        });
    }

    private _handleLanguageChange() {
        Lobby.setting.on(GameSettingName.PreferredLanguage, () => {
            this.i18n.changeLanguage(Lobby.setting.PreferredLanguage);
        });
    }

    private _openPage(pageName: NodeName) {
        const { webViewManager } = this._sharedAsset;
        if (webViewManager.isGamePlaying) {
            webViewManager.handleGameView(true);
        }
        if (!this._pages[pageName]) {
            this._pages[pageName] = this.scene.getNode(pageName).getComponent(Page);
        }
        const page = this._pages[pageName];
        page.open();
        page.once(Page.EVENT_TYPE.CLOSE_END, () => {
            if (webViewManager.isGamePlaying) {
                webViewManager.handleGameView(false);
            }
        });
    }
}
